export const TURN_TO_SITE_ID = process.env.NEXT_PUBLIC_TURN_TO_SITE_ID;
export const TURN_TO_MINIMUM_REVIEWS_THRESHOLD =
  (process.env.NEXT_PUBLIC_TURN_TO_MINIMUM_REVIEWS_THRESHOLD &&
    Number(process.env.NEXT_PUBLIC_TURN_TO_MINIMUM_REVIEWS_THRESHOLD)) ||
  5;
